// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"24":"reset","193":"statistics","328":"admin","401":"workouts","845":"profile"}[chunkId] + "." + {"24":"e2527ec6","193":"91fe968e","328":"73df498d","401":"1f6e4a1d","845":"203e78e2"}[chunkId] + ".css";
};